import React, { useState } from 'react'
import { BotIcon } from '../icons/icons'

export interface BuildWithAIButtonProps {
  onClick: () => void
  theme?: 'light' | 'dark'
}

/**
 * Shared header trigger for the "Build using AI" page (BuildWithAIPage). Previously each studio
 * (Flow Studio, App Studio, Form Studio) inlined its own copy of this button, all drifting
 * slightly in size/markup. Icon-only at rest with a hover tooltip, so it stays out of the way of
 * the rest of the header chrome — the full label is still one hover away, not hidden.
 */
export const BuildWithAIButton: React.FC<BuildWithAIButtonProps> = ({ onClick, theme = 'dark' }) => {
  const [hovered, setHovered] = useState(false)
  const isDark = theme === 'dark'
  const accent = '#309B48'

  return (
    <div style={{ position: 'relative', display: 'inline-flex' }}>
      <button
        onClick={onClick}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        onFocus={() => setHovered(true)}
        onBlur={() => setHovered(false)}
        aria-label="Build using AI"
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '40px',
          height: '40px',
          padding: 0,
          borderRadius: '6px',
          border: `1px solid rgba(48, 155, 72, 0.4)`,
          background: 'rgba(48, 155, 72, 0.12)',
          color: accent,
          cursor: 'pointer',
          flexShrink: 0,
        }}
      >
        <BotIcon size={24} />
      </button>
      {hovered && (
        <div
          role="tooltip"
          style={{
            position: 'absolute',
            top: 'calc(100% + 6px)',
            right: 0,
            padding: '5px 10px',
            borderRadius: '6px',
            fontSize: '12px',
            fontWeight: 500,
            whiteSpace: 'nowrap',
            color: isDark ? '#f8fafc' : '#111827',
            background: isDark ? '#1e293b' : '#ffffff',
            border: isDark ? '1px solid rgba(255,255,255,0.12)' : '1px solid #e5e7eb',
            boxShadow: '0 4px 10px rgba(0, 0, 0, 0.25)',
            zIndex: 50,
            pointerEvents: 'none',
          }}
        >
          Build using AI
        </div>
      )}
    </div>
  )
}

export default BuildWithAIButton
